module.exports = __webpack_public_path__ + "static/media/Contact.680bd93a.svg";